import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import { useHistory } from 'react-router-dom'

import DropdownMenu from 'components/DropdownMenu/DropdownMenu'
import Image from 'components/Form/Image'

import { TAB_TYPES } from '../../utils/constants'
import { getOrganizationById } from 'common/services/OrgService'
import iconPlus from './i/iconPlus.svg'
import iconTemplates from './i/iconTemplates.svg'

import './TopBar.scss'
import { getFullUrlToSsr } from '../../../../utils/router'

const TopBar = ({ tab, projects, onChangeTab, onCreateFromScratch }) => {
    const { t } = useTranslation()
    const history = useHistory()
    const {
        organizations: { selectedMember, selectedOrganizationId },
        user_details,
    } = useSelector(state => ({
        organizations: state.organizations,
        user_details: state.user_details,
    }))
    const selectedOrganization = getOrganizationById(selectedOrganizationId)

    const createProjectMenu = [
        <div
            className="create-project__dropdown-menu-item"
            onClick={() => onCreateFromScratch()}
            data-test="create-project-from-scratch"
        >
            <Image src={iconPlus} alt="from scratch" width={28} height={24} />
            <span>{t('Create from scratch')}</span>
        </div>,
        <a
            className="create-project__dropdown-menu-item"
            href={getFullUrlToSsr('/template-gallery')}
            data-test="create-project-from-template"
        >
            <Image src={iconTemplates} alt="from templates" width={28} height={24} />
            <span>{t('Choose a template')}</span>
        </a>,
    ]

    return (
        <div className="my-project-top-bar">
            <div className="title">
                <div className="my-project-top-bar__organization-icon">
                    {selectedOrganization.logoURL ? (
                        <img src={selectedOrganization.logoURL} />
                    ) : (
                        selectedOrganization.name.charAt(0).toUpperCase()
                    )}
                </div>
                <div className="my-project-top-bar__organization-info">
                    <h2 className="my-project-top-bar__organization-title">{selectedOrganization.name}</h2>
                    {selectedMember && (
                        <h2 className="my-project-top-bar__selected-member">
                            {t(selectedMember.name)}
                            {selectedMember.userId === user_details.id && (
                                <span className="my-project-top-bar__selected-member-postfix">{t('(You)')}</span>
                            )}
                        </h2>
                    )}
                </div>
            </div>
            <div className="tab">
                <ul>
                    <li
                        className={classNames({
                            'is-active': tab === TAB_TYPES.draft,
                        })}
                        onClick={evt => onChangeTab(TAB_TYPES.draft, evt)}
                    >
                        {t('Drafts')}
                        <span>{projects.draft.count}</span>
                    </li>
                    <li
                        className={classNames({
                            'is-active': tab === TAB_TYPES.published,
                        })}
                        onClick={evt => onChangeTab(TAB_TYPES.published, evt)}
                    >
                        {t('Published ')}
                        <span>{projects.published.count}</span>
                    </li>
                </ul>
            </div>
            <div className="actions">
                <DropdownMenu
                    placement={'bottomRight'}
                    actionHtml={
                        <button
                            className="button-style create-project-link"
                            data-size="md"
                            data-variant="primary-light"
                            data-test="create-project-dropdown"
                        >
                            +<span>&nbsp;{t('Create')}</span>
                        </button>
                    }
                    items={createProjectMenu}
                />
            </div>
        </div>
    )
}

export default TopBar
